import styled from 'styled-components'

export const StyledNewsVehicleTypeSelect = styled.div``
